import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosConfig from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";
import { ControlsUpdateType } from "types/ControlsType";

export const useUpdateBot = (
  options?: UseMutationOptions<any, Error, ControlsUpdateType>,
  withoutToast?: boolean
) => {
  return useMutation({
    mutationKey: ["UpdateBot"],
    mutationFn: async (data: ControlsUpdateType) => {
      return axiosConfig.put(`/controls`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      if (!withoutToast) {
        Toast({
          message: "Ładowanie...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "UpdateBot",
        });
      }
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Pomyślnie zaktualizowano filtry",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "UpdateBot",
        });
      }
      queryClient.invalidateQueries({ queryKey: ["controls"] });

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Błąd podczas aktualizacji filtrów",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "UpdateBot",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
